import { z } from "zod";
/**
 * Document types whose single line account can be changed in place through
 * `update_document_line_account` (migration 20260928153323), which re-submits
 * the document through its existing update RPC — one validation path.
 */
export const lineAccountDocumentTypeSchema = z.enum(["expense", "ap_bill", "ar_invoice"]);
/** Body of `PATCH /api/v1/line-accounts/orgs/:orgId/:documentType/:documentId`. */
export const updateLineAccountSchema = z
    .object({
    account_id: z.string().uuid(),
})
    .strict();
//# sourceMappingURL=lineAccount.js.map